export default __webpack_public_path__ + "static/media/hmm.e69b535b.png";